import { CmsRegistrationConfirmationPage } from '../../models/registration-confirmation/cms-registration-confirmation-page.type';
import { mockCmsProtectionCardBanner } from '../cms/cms-protection-card-banner.mock';
import { mockCmsRegisterAnotherAppliancePanel } from '../cms/cms-register-another-appliance-panel.mock';
import { mockCmsRegistrationRoot } from '../cms/cms-registration-root.mock';
import { mockCmsInstallationInstructionPanel } from './cms-installation-instruction-panel.mock';
import { mockCmsPaperlessInstructionPanel } from './cms-paperless-instruction-panel.mock';
import { mockCmsRegistrationSummaryPanel } from './cms-registration-summary-panel.mock';

export const mockCmsRegistrationConfirmationPage: CmsRegistrationConfirmationPage =
  {
    ...mockCmsInstallationInstructionPanel,
    ...mockCmsPaperlessInstructionPanel,
    ...mockCmsProtectionCardBanner,
    ...mockCmsRegisterAnotherAppliancePanel,
    ...mockCmsRegistrationRoot,
    ...mockCmsRegistrationSummaryPanel,
  };
